import { forwardRef, ReactNode } from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, SxProps, Theme } from '@mui/material';

interface HelmetContainerProps {
  children: ReactNode;
  title?: string;
  content?: string;
  sx?: SxProps<Theme>;
}

const HelmetContainer = forwardRef<HTMLDivElement, HelmetContainerProps>(
  ({ children, title = '', content = '', sx, ...other }, ref) => (
    <Box ref={ref} sx={{ ...sx }} {...other}>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={content} />
      </Helmet>
      {children}
    </Box>
  ),
);

HelmetContainer.displayName = 'HelmetContainer';

export default HelmetContainer;
